import React from 'react';
import AdminDashboard from './AdminDashboard';

const AdminPage = () => {
  return (
    <div>
      <AdminDashboard />
    </div>
  );
};

export default AdminPage;
